import React, { Component } from 'react'
import logo from './assets/img/logo.svg'
import icon_tw2 from './assets/img/icon_tw2.png'
import icon_fb2 from './assets/img/icon_fb2.png'

class Notfound extends Component {

  render() {
    return (
      <section id="section-home" className="section-1 color-1">
      <div className="section-content">
      <h1 className="section-title">Not found!</h1>
      <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
      className="section-subtitle">Sorry, the page you are looking for is not available </h3>
    </div>
  </section>
    );
  }
}

export default Notfound;



// WEBPACK FOOTER //
// ./src/components/Notfound.js